// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"9681ce85","380":"ee911e51","597":"8ab4bc4f"}[chunkId] + ".chunk.css";
};